import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "../../../ui-elements/Tooltip/Tooltip";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { CountryList } from "../../../assets/staticData/CountryList";

export const boardMemberTypes = ["4", "5", "6", "7"];

export const getCompanyQuestionDescription = (questionId: number, serviceCompany: string): string | undefined => {
  switch (questionId) {
    case 3:
      return `Tilgreindu uppruna þeirra fjármuna sem notaðir eru til viðskipta við ${serviceCompany}.`;
    case 4:
      return "Ósamvinnuþýð ríki falla undir skilgreiningu FATF sbr. reglugerð 956/2020.";
    case 5:
      return `Hver er tilgangur fyrirhugaðra viðskipta, þ.e. þjónustu sem þú munt nýta þér hjá ${serviceCompany}?`;
    case 6:
      return "Er sú þjónusta sem þú sækist eftir vegna þriðja aðila, en ekki þín eða félags sem þú ert í forsvari fyrir?";
    case 7:
      return "Til einstaklinga í áhættuhópi vegna stjórnmálalegra tengsla teljast þeir einstaklingar, innlendir og erlendir, sem eru eða hafa verið háttsettir í opinberri þjónustu, ásamt nánustu fjölskyldu þeirra og nánum samstarfsmönnum.";
    case 8:
      return "Hefur einhver af stjórnendum félagsins eða aðrir sem hafa heimild til að skuldbinda félagið, þeirra nánasta fjölskylda eða nánir samstarfsmenn verið háttsettir í opinberri þjónustu síðastliðna tólf mánuði?";
    case 9:
      return "Raunverulegur eigandi telst sá einstaklingur sem á eða ræður yfir >25% hlut í félaginu, beint eða óbeint. Staðfesta raunverulega eigendur?";
    case 10:
      return "Staðfesta upplýsingar úr fyrirtækjaskrá?";
  }
  return undefined;
};

export const getIndividualQuestionDescription = (questionId: number, serviceCompany: string): string | undefined => {
  switch (questionId) {
    case 1:
      return "Vinsamlega tilgreinið heimilisfang og póstnúmer.";
    case 4:
      return `Hver er tilgangur fyrirhugaðra viðskipta, þ.e. þjónustu sem þú munt nýta þér hjá ${serviceCompany}?`;
    case 5:
      return "Ert þú eigandi þeirra fjármuna sem notaðir eru í viðskiptasambandinu?";
    case 6:
      return "Tilgreindu uppruna þeirra fjármuna sem notaðir eru í viðskiptasambandinu.";
    case 7:
      return "Til einstaklinga í áhættuhópi vegna stjórnmálalegra tengsla teljast þeir einstaklingar, innlendir og erlendir, sem eru eða hafa verið háttsettir í opinberri þjónustu, ásamt nánustu fjölskyldu þeirra og nánum samstarfsmönnum.";
  }
  return undefined;
};

export const AthaettusomRikiTooltipColumnHeader = (text: "Ríkisfang" | "Búsetuland" | "Búseta") => <Tooltip tableHeader tooltipClassName="tooltip-athugunarlisti" tooltip={<div className="tooltip-text">
  <p><strong>Áhættusöm / ósamvinnuþýð ríki</strong></p>
  Tilkynningarskyldum aðilum sem eiga í viðskiptum við aðila sem tengjast áhættusömum og ósamvinnuþýðum ríkjum,
  er skilt að framkvæma aukna áreiðanleikakönnun á þeim í samræmi við 13. og 14. gr. laga nr. 140/2018. <br />
  Kerfið keyrir á móti gagnagrunni Keldunnar sem heldur utanum áhættusöm og ósamvinnuþýð ríki í samræmi við 6. gr. laga nr. 140/2018.
</div>} text={text} />;

export const StjornmalalegTengslPEPTooltipColumnHeader = <Tooltip
  tableHeader
  tooltipClassName="viewCompanyAnswers-tooltip"
  tooltip={<div className="tooltip-text">
    <p><strong>Stjórnmálaleg tengsl</strong></p>
    Keldan heldur úti íslenskum PEP lista sem inniheldur einstaklinga sem eru eða hafa verið háttsettir í opinberri þjónustu ásamt nánustu fjölskyldu og samstarfsmönnum á síðustu 12 mánuðum.
    Samkvæmt 1. mgr. 17. gr. peningaþvættislaga ber tilkynningaskyldum aðilum að kanna hvort viðskiptamaður eða raunverulegur eigandi lögaðila sé í áhættuhópi vegna stjórnmálalegra tengsla.
    Sjálfvirk uppfletting kerfisins er þ.a.l. á viðskiptamanni eða þeim sem kemur fram f.h. lögaðila, prókúruhöfum og raunverulegum eiganda/eigendum.</div>}
  text={'Stjórnmálaleg tengsl'} />

export const AlthjodlegirValistarTooltipColumnHeader = <Tooltip
  tableHeader
  tooltipClassName="viewCompanyAnswers-tooltip"
  tooltip={<div className="tooltip-text">
    <p><strong>Alþjóðlegir válistar</strong></p>
    Sbr. lög nr. 140/2018 um peningaþvætti og lög nr. 68/2023 um frystingu fjármuna og um framkvæmd alþjóðlegra þvingunaraðgerða,
    ber tilkynningarskyldum aðilum að kanna hvort viðskiptavinir séu á slíkum alþjóðlegum válistum. Listarnir sem kerfið keyrir á móti uppfylla kröfur
    AML5, FATF, UNCAC, JMLSG, UK/FCA og Wolfsberg Group um peningaþvætti, alþjóðlega þvingunar-, viðskiptaþvingunar- og refsiválista.</div>}
  text={"Alþjóðlegir válistar"} />

export const RenderNationalityWithTooltip = (
  Nationality: string | undefined,
  Nationalityflagged: boolean | string | undefined | null
) => {
  // Check if nationality should be flagged
  // We consider it flagged if the value is:
  // - Not undefined
  // - Not boolean false
  // - Not an empty string
  // - Not the string 'false'
  const isNationalityFlagged =
    Nationalityflagged !== null &&
    Nationalityflagged !== undefined &&
    Nationalityflagged !== false &&
    Nationalityflagged !== '' &&
    Nationalityflagged !== 'false';

  return (
    <div className="rikisfang-wrapper">
      <span>{CountryList.find(country => country.value === Nationality)?.label || Nationality}</span>
      {/* Show warning tooltip if nationality is flagged */}
      {isNationalityFlagged &&
        <Tooltip
          tooltipClassName="tooltip-gildandiSkraning"
          noUnderline
          tooltip={
            <div className="tooltip-text">
              Athugið að þetta ríkisfang gæti verið á lista yfir áhættusöm og ósamvinnuþýð ríki.
            </div>
          }
          text={<FontAwesomeIcon icon={faCircleExclamation} />}
        />
      }
    </div>
  );
}